export const formatPrice = (value) =>
  new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(value || 0);

// Shows "POA" (Price On Application) when the vehicle is flagged, otherwise the formatted price
export const displayPrice = (vehicle) => (vehicle?.poa ? 'POA' : formatPrice(vehicle?.price));

export const formatKm = (value) =>
  `${new Intl.NumberFormat('en-AU').format(value || 0)} km`;

export const formatDate = (iso) => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '-';
  }
};
